import { Button, createBemBlockBuilder, Hyperlink } from "@ebsco-ui/ebsco-ui";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./primary-footer.scss";
import type { PrimaryFooterProps } from "./types";

export const URLS = {
  PRIVACY_POLICY: "https://www.ebsco.com/company/privacy-policy/",
  TERMS_OF_USE: "https://www.ebsco.com/terms-of-use/",
  LOGOUT: "/logout?returnTo=?acr_values=uid",
};

const BASE_CLASSNAME = "nuc-primary-footer";

const PrimaryFooter = ({
  logoutUrl = URLS.LOGOUT,
  shouldRenderManageMyCookies,
  sessionType,
  messages,
  onLinkClick,
  onManageCookiesClick,
  className,
}: PrimaryFooterProps) => {
  const getBlocksWith = createBemBlockBuilder([BASE_CLASSNAME, className]);
  const getDataAutoWith = (append?: string) =>
    append ? `${BASE_CLASSNAME}${append}` : BASE_CLASSNAME;

  const year = new Date().getFullYear();

  const footerItems = [
    {
      className: "privacy-policy",
      enabled: true,
      message: messages.privacyPolicy,
      url: URLS.PRIVACY_POLICY,
      isExternalLink: true,
    },
    {
      className: "terms-of-use",
      enabled: true,
      message: messages.termsOfUse,
      url: URLS.TERMS_OF_USE,
      isExternalLink: true,
    },
    {
      className: "institutional-logout",
      enabled: !(sessionType === "personal"),
      message: messages.institutionalLogout,
      url: logoutUrl,
      isExternalLink: false,
    },
  ];

  return (
    <footer className={getBlocksWith()} data-auto={getDataAutoWith()}>
      <ul
        className={getBlocksWith("__list")}
        data-auto={getDataAutoWith("-list")}
      >
        {footerItems.map(
          ({ className, enabled, message, url, isExternalLink }) => {
            const linkDestinationProps = isExternalLink
              ? { target: "_blank", rel: "noopener noreferrer" }
              : { target: "_self" };
            return (
              enabled && (
                <li
                  key={message.id}
                  className={getBlocksWith("__list-item")}
                  data-auto={getDataAutoWith(`-list-item-${className}`)}
                >
                  <Hyperlink
                    onClick={() =>
                      onLinkClick?.({
                        itemId: message.id,
                        url,
                      })
                    }
                    href={url}
                    {...linkDestinationProps}
                  >
                    <FormattedMessage {...message} />
                  </Hyperlink>
                </li>
              )
            );
          },
        )}
        {shouldRenderManageMyCookies && (
          <li
            className={getBlocksWith("__list-item")}
            data-auto={getDataAutoWith("-list-item-manage-my-cookies")}
          >
            <Button
              styleType="flat-icon"
              className={getBlocksWith("__manage-my-cookies")}
              data-auto={getDataAutoWith("-manage-my-cookies")}
              onClick={onManageCookiesClick}
            >
              <FormattedMessage {...messages.manageMyCookies} />
            </Button>
          </li>
        )}
      </ul>
      <div
        className={getBlocksWith("__copyright")}
        data-auto={getDataAutoWith("-copyright")}
      >
        <FormattedMessage {...messages.ebscoCopyright} values={{ year }} />
      </div>
    </footer>
  );
};

export default PrimaryFooter;
